// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LDKP","newExpiryDate":"styles_newExpiryDate__2yQse","footer":"styles_footer__cR7Te"};